export const DEFAULT_COMMENT_LIMIT = 2;
export const BACKEND_LIMIT = 3000;
export const LIST_URL = 'domik/comments/comments-list';
export const FORM_CONTROLLER = 'comment/editor';
